// extracted by mini-css-extract-plugin
export default {"bloblangWidget":"ComponentForm_bloblangWidget__DP-2A","bigTextWidget":"ComponentForm_bigTextWidget__Xtb4k"};